export default __webpack_public_path__ + "static/media/003-server.25d3d94f.svg";